/** @format */

import React from "react";

function Team() {
  return (
    <>
      {/* Page Header Start */}
      <div className="container-fluid page-header py-5 mb-5">
        <div className="container py-5">
          <h1 className="display-3 text-white mb-3 animated slideInDown">
            Our Team
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a className="text-white" href="#">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <a className="text-white" href="#">
                  Pages
                </a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Our Team
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* Page Header End */}
      {/* Team Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "600px" }}
          >
            <h6 className="text-primary">Team Member</h6>
            <h1 className="mb-4">Experienced Team Members</h1>
          </div>
          <div className="row g-4">
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-1.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>George</h5>
                  <span>Designation: Architect</span>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-2.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>Finn</h5>
                  <span>Designation: Civil Engineer</span>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-3.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>Rohan</h5>
                  <span>Designation: Development Engineer</span>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-2.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>Ray</h5>
                  <span>Designation: Electrical Designer</span>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-3.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>Raj</h5>
                  <span>Designation: Electrical Designer</span>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="team-item rounded overflow-hidden">
                <div className="d-flex">
                  <img className="img-fluid w-75" src="img/team-1.jpg" alt="" />
                  <div className="team-social w-25">
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-twitter" />
                    </a>
                    <a
                      className="btn btn-lg-square btn-outline-primary rounded-circle mt-3"
                      href
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <div className="p-4">
                  <h5>Jack</h5>
                  <span>Designation: Field Engineer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Team End */}
    </>
  );
}

export default Team;
